import script from "./AccountsMixin.vue?vue&type=script&lang=js"
export * from "./AccountsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__